import { menuButtonEvents } from './functions/buttons.js';
import { dropdownNavigation } from './functions/dropdown.js';

//=====================================================================
// This script is for a mobile menu toggle button and navigation with dropdown items
// Required attributes
//=====================================================================
// Header attribute: <header data-headerFunctions
// Menu/Nav attribute: <div data-menu
// Mobile Menu Button: <button data-menuButton
// Dropdown Parent: <li data-dropdown
// Dropdown Button: <button data-dropdownButton

//=====================================================================
// Other Required Items
//=====================================================================
// <button data-menuBodyOverlay aria-expanded="false" type="button">Close</button>

function headerJS() {
    const headerFunctions = document.querySelector('[data-headerFunctions]');

    if (headerFunctions) {
        const body = document.body;
        const menu = headerFunctions.querySelector('[data-menu]');
        
        menuButtonEvents(headerFunctions, body, menu);
        dropdownNavigation(menu);
    }
}

// Self-invoke the function
headerJS(); 

// Export the function for potential use in other files
export { headerJS };